import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventService {
  private eventSubject = new Subject<{ eventName: string; payload: any }>();

  // Emit an event
  emit(eventName: string, payload?: any): void {
    this.eventSubject.next({ eventName, payload });
  }

  // Listen for specific events
  on(eventName: string): Observable<any> {
    return new Observable(observer => {
      const subscription = this.eventSubject.subscribe(event => {
        if (event.eventName === eventName) {
          observer.next(event.payload);
        }
      });
      
      // Return cleanup function
      return () => subscription.unsubscribe();
    });
  }

  // Emit user authentication event (replacement for $rootScope.$emit)
  emitUserAuthenticated(didAuthSucceed: boolean): void {
    this.emit('userAuthenticated', { didAuthSucceed });
  }
}
